import {
  queryOptions,
  useMutation,
  useQueryClient,
} from "@tanstack/react-query";
import { api } from "../apiClient";

export const generatePayload = (classData, member_id, processed_date) => {
  return {
    classes: classData,
    member_id,
    processed_date,
  };
};

export const putMemberClasses = data => {
  return api.put(`admin/member-classes`, data);
};

export const putMemberClassesQueryOptions = (data, meta) => {
  return queryOptions({
    queryKey: ["put-member-classes", data],
    queryFn: () => putMemberClasses(data),
    meta,
  });
};

export const usePutMemberClassesMutation = ({ mutationConfig }) => {
  const queryClient = useQueryClient();

  const { onSuccess, ...restConfig } = mutationConfig || {};

  return useMutation({
    onSuccess: async (data, ...args) => {
      await onSuccess?.(data, ...args);
      queryClient.invalidateQueries();
    },
    ...restConfig,
    mutationFn: putMemberClasses,
  });
};
